import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import LoginView from './LoginView';

@inject(({ commonStore }) => ({
  sessionLoginInfo: commonStore.sessionLoginInfo,
}))
@observer
class Container extends Component {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.sessionLoginInfo !== this.props.sessionLoginInfo) {
      if (nextProps.sessionLoginInfo) {
        // console.log('Login Ok MainPage Go');
        this.props.history.push('/');
      }
    }
  }

  render() {
    return (
      <Fragment>
        <LoginView />
      </Fragment>
    );
  }
}

export default withRouter(Container);
